import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const Content = styled.div`
  padding: 24px;
  text-align: center;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
  color: ${colors.darkBlue500};
`

export const Message = styled.div`
  font-size: 14px;
  color: ${colors.gray900};
  margin-bottom: 8px;
`

export const Countdown = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: ${colors.orange300};
  margin: 16px 0;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 16px;
`
